import gql from 'graphql-tag';

import type { EntityComplianceData } from 'src/data/compliance';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryComplianceForVariationsArgs } from 'src/types/backend';

import { FRAGMENT_VARIATION_COMPLIANCE } from './schema';

const QUERY = gql`
  query ComplianceForVariations($variationIds: [ID!]!) {
    complianceForVariations(variationIds: $variationIds) {
      ...VariationCompliance
    }
  }
  ${FRAGMENT_VARIATION_COMPLIANCE}
`;

type Variables = BackendQueryComplianceForVariationsArgs;
type Result = EntityComplianceData[];

export const queryComplianceForVariations = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
